import { v4 as uuidv4 } from "uuid";
import type { BaseBlock } from "@circle-react-shared/BuilderUI/DataModel.types";
import { createImageBlock } from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/mediaBlockHelpers";
import {
  createH5Block,
  createPBlock,
} from "@circle-react-shared/BuilderUI/DefaultBlocks/utils/textBlocksHelpers";
import { getBorderRadiusOptions } from "../../../utils/buttonStyleHelpers";
import { getSizingOptions } from "../../../utils/sizeStyleHelpers";

export const defaultData: BaseBlock = {
  id: uuidv4(),
  type: "FeatureCard1",
  props: {
    content: {
      prop: "children",
      type: "children",
      value: [
        createImageBlock({
          signedId: "",
          styles: {
            borderRadius: getBorderRadiusOptions({
              defaultValue: {
                border_left_top_radius: "100",
                border_left_bottom_radius: "100",
                border_right_top_radius: "100",
                border_right_bottom_radius: "100",
              },
            }),
            sizing: getSizingOptions({
              defaultValue: {
                width: "54px",
                height: "54px",
                minWidth: "54px",
                minHeight: "54px",
                maxWidth: "54px",
                maxHeight: "54px",
              },
            }),
          },
        }),
        createH5Block({
          text: "Personalized Coaching Approach",
        }),
        createPBlock({
          text: "Unlike one-size-fits-all programs, we create a custom roadmap based on your unique strengths, challenges, and career aspirations. No generic advice—just strategies that work for your situation.",
        }),
      ],
    },
  },
};
